import React from "react";

export const Device = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="84" height="84" viewBox="0 0 84 84" fill="none">
            <path d="M11 21C11 19.3431 12.3431 18 14 18H70C71.6569 18 73 19.3431 73 21V59H11V21Z" stroke="#BBBBBB"
                  strokeWidth="2"/>
            <rect x="5" y="58" width="74" height="5" rx="2" fill="#BBBBBB"/>
            <path d="M48 57H36V59H48V57Z" fill="#FE9235"/>
            <rect x="62" y="32" width="19" height="34" rx="2" fill="#FE9235"/>
            <rect x="67" y="34" width="9" height="1" fill="white"/>
            <circle cx="71.5" cy="62.5" r="1.5" fill="white"/>
        </svg>
    )
}
